module.exports = __webpack_public_path__ + "img/utility_driving.fe373f2d.svg";